module.exports = __webpack_public_path__ + "static/img/bgimg4-3.6d96fdd1.png";